import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import {
  chatContainerStyles,
  avatarContainerStyles,
  messageContainerStyles,
} from './styles';
import PompConciergeIcon from './pomp-concierge-avatar-icon.jpeg';
import PropTypes from 'prop-types';
import React from 'react';
import TextBody from '../Message/TextBody';

const PompConciergeMessage = ({ message }) => (
  <Box sx={chatContainerStyles()}>
    <Box sx={messageContainerStyles}>
      <Box sx={avatarContainerStyles}>
        <Avatar alt="Pomp Concierge" src={PompConciergeIcon} />
      </Box>

      <TextBody
        isOutgoing={false}
        cleanBody={message}
        message={{
          body: message,
          isLastMessageInParticipantBatch: true,
          timestamp: new Date(),
        }}
      />
    </Box>
  </Box>
);

PompConciergeMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default PompConciergeMessage;
